var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadProfileCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:camera-bold"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8335 18.6993H14.1665C16.5072 18.6993 17.678 18.6993 18.5187 18.148C18.8816 17.9104 19.1941 17.6035 19.4382 17.245C20 16.42 20 15.2703 20 12.9723C20 10.6743 20 9.5245 19.4382 8.6995C19.1941 8.341 18.8816 8.03415 18.5187 7.7965C17.9787 7.44175 17.3022 7.315 16.2665 7.27C15.7722 7.27 15.347 6.9025 15.2502 6.42625C15.1763 6.07741 14.9842 5.76478 14.7064 5.54122C14.4286 5.31765 14.0821 5.19686 13.7255 5.19925H11.2745C10.5335 5.19925 9.89525 5.713 9.74975 6.42625C9.653 6.9025 9.22775 7.27 8.7335 7.27C7.6985 7.315 7.022 7.4425 6.48125 7.7965C6.11865 8.03422 5.80646 8.34107 5.5625 8.6995C5 9.5245 5 10.6735 5 12.9723C5 15.271 5 16.4193 5.56175 17.245C5.80475 17.602 6.11675 17.9088 6.48125 18.148C7.322 18.6993 8.49275 18.6993 10.8335 18.6993ZM12.5 9.904C10.7743 9.904 9.37475 11.2773 9.37475 12.9715C9.37475 14.6658 10.775 16.0413 12.5 16.0413C14.225 16.0413 15.6252 14.6673 15.6252 12.973C15.6252 11.2788 14.225 9.904 12.5 9.904ZM12.5 11.131C11.465 11.131 10.625 11.9553 10.625 12.9723C10.625 13.9885 11.465 14.8128 12.5 14.8128C13.535 14.8128 14.375 13.9885 14.375 12.9723C14.375 11.956 13.535 11.131 12.5 11.131ZM16.0415 10.5175C16.0415 10.1785 16.3212 9.904 16.667 9.904H17.4995C17.8445 9.904 18.125 10.1785 18.125 10.5175C18.1234 10.6817 18.0567 10.8385 17.9396 10.9535C17.8224 11.0686 17.6644 11.1324 17.5002 11.131H16.667C16.5856 11.1318 16.5049 11.1166 16.4295 11.0862C16.354 11.0557 16.2853 11.0108 16.2272 10.9538C16.1691 10.8968 16.1228 10.829 16.0909 10.7541C16.0591 10.6793 16.0423 10.5989 16.0415 10.5175Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadProfileCameraIcon);
export default __webpack_public_path__ + "static/media/upload_profile_camera_icon.789ad968bad980caae6bfcf7cf37ccf8.svg";
export { ForwardRef as ReactComponent };